import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { TutorialTooltipReducer as tutorial } from '@adc/ui-adc'
import assets from './assets'
import featureFlags from './featureFlags'
import user from './user'
import savedSearch from './savedSearch'
import notification from './notification'
import marketingTagsConfig from './marketingTagsConfig'

export default combineReducers({
  assets,
  featureFlags,
  marketingTagsConfig,
  user,
  savedSearch,
  notification,
  tutorial,
  form: formReducer,
})
